import whatIsCryptoTradingJson from './content/what-is-cryptocurrency-trading.json';

export const whatIsCryptoTradingMock = {
    layoutType: 2,
    data: {
        name: 'what-is-cryptocurrency-trading',
        areasList: [
            {
                id: 1,
                name: 'WhatIsCryptoTradingPage',
                componentName: 'Comp:WhatIsCryptoTradingPage',
                content: JSON.stringify(whatIsCryptoTradingJson)
            }
        ]
    }
};
